import { getAcceptByFileType } from '@fi-shared/utils/get-accept-by-file-type';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FileType, ObjectTypes } from '@fi-shared/types';

export class FileUploadModel {
    OnFileSelect: (files: ArrayLike<any>, fromCamera?: boolean) => void;
    multiple: boolean;
    DropFilesTextId: any;
    accept: string;
    fileTypes: FileType[];
    acceptValidate: (file) => void; // todo line it is not used, why?
    SelectFilesTextId: string;
    SelectFilesIconClass: any;
    FilesLoading: boolean = false;

    //SkipToggleLoadingOnProcessFiles = false;

    private _objectType: ObjectTypes;
    get objectType() {
        return this._objectType;
    }

    private _browseMediaDoneCallback: (mediaBankFileReferences: IMediaBankFileReference[]) => void;
    get browseMediaDoneCallback() {
        return this._browseMediaDoneCallback;
    }

    protected _showBrowseMediaBank = false;
    get showBrowseMediaBank() {
        return this._showBrowseMediaBank;
    }

    constructor(OnFileSelect?: (files: FileList) => void) {
        this.OnFileSelect = OnFileSelect;
        this.multiple = false;
        this.accept = '*';
        this.DropFilesTextId = null;
        this.SelectFilesTextId = 'ccmFileUpload.browseLocally';
        this.SelectFilesIconClass = undefined;
        this._showBrowseMediaBank = false;
    }

    getAcceptByFileTypes(fileTypes: FileType[], additionalMimeTypes?) {
        return getAcceptByFileType(fileTypes, additionalMimeTypes);
    }

    setBrowseMediaBankDone(
        objectType: ObjectTypes,
        callback: (mediaBankFileReferences: IMediaBankFileReference[]) => void,
    ) {
        this._objectType = objectType;
        this._browseMediaDoneCallback = callback;
        this._showBrowseMediaBank = true;
    }

    resetBrowseMediaBankDone() {
        this._objectType = undefined;
        this._browseMediaDoneCallback = undefined;
        this._showBrowseMediaBank = false;
    }
}

export class FileUploadModelWithTakePhoto extends FileUploadModel {
    constructor(OnFileSelect: (files: FileList, fromCamera?: boolean) => void, isMobilePhone: boolean) {
        super(OnFileSelect);

        this._showBrowseMediaBank = !isMobilePhone;
        if (isMobilePhone) this.setSelectFilesAppearance();
    }

    setSelectFilesAppearance() {
        this.SelectFilesIconClass = 'fa fa-picture-o';
        this.SelectFilesTextId = 'upload_photo_mobile.btn_browse';
    }
}
